import { type APIConnections, type HTTPSchema, type WebsocketConnections } from './types';

// Shallow clone to fix issues with empty values
const env = Object.assign({}, process.env);

const defaultConnectionOptions = {
    protocol: 'https' as HTTPSchema,
};
export const apiConnections: APIConnections = {
    api: {
        ...defaultConnectionOptions,
        url: env.REACT_APP_API_URL || 'https://y.at/a',
    },
    yat: {
        ...defaultConnectionOptions,
        url: env.REACT_APP_API_URL || 'https://y.at/a',
    },
    yatNode: {
        ...defaultConnectionOptions,
        url: env.REACT_APP_API_URL_NBE || 'https://y.at/nbe',
        proxyPath: env.REACT_APP_API_PROXY_NBE,
    },
    daas: {
        ...defaultConnectionOptions,
        url: env.REACT_APP_API_URL_DAAS || 'https://y.at/yacs/api/proxy',
        proxyPath: env.REACT_APP_API_PROXY_DAAS,
    },
    daasV2: {
        ...defaultConnectionOptions,
        url: env.REACT_APP_API_URL_DAASV2 || 'https://daas.y.at/v2',
        proxyPath: env.REACT_APP_API_PROXY_DAASV2,
    },
    daasGraphQL: {
        ...defaultConnectionOptions,
        url: env.REACT_APP_API_URL_DAASGQL || 'https://daas-gql.yat.fyi/api/rest',
    },
    gs: {
        ...defaultConnectionOptions,
        url: env.REACT_APP_API_URL_GS || 'https://y.at/s',
        proxyPath: env.REACT_APP_API_PROXY_GS,
    },
    auth: {
        ...defaultConnectionOptions,
        url: env.REACT_APP_API_URL_AUTH || 'https://micro.yat.fyi/s',
        proxyPath: env.REACT_APP_API_PROXY_AUTH,
    },
    marketplace: {
        ...defaultConnectionOptions,
        url: env.REACT_APP_API_URL_GQL || 'https://micro.y.at/gql',
        proxyPath: env.REACT_APP_API_PROXY_GQL,
    },
    fantasyAlpha: {
        ...defaultConnectionOptions,
        url: env.REACT_APP_API_URL_FANTASY || 'https://fantasy.y.at',
        proxyPath: env.REACT_APP_API_PROXY_FANTASY,
    },
};

export const websocketConnections: WebsocketConnections = {
    api: {
        url: env.REACT_APP_API_URL_WS || 'wss://y.at/a',
    },
    yacs: {
        url: env.REACT_APP_API_URL_WS_YACS || 'wss://y.y.at',
        pathname: env.REACT_APP_API_URL_WS_PATHNAME || '/websocket',
    },
};
